/**
 * @description This object maps the feature class names to the map layer titles.
 *     It includes all the layers in the Incident and Analysis Groups.
 *     The keys of the object are the name of the feature classes in the WFDSS geodatabase.
 *     This provides a way to map the corresponding feature class name to the map layer 
 *     title and provide a single reference to the map layer title.
 */

const incidentsStartYear = 2025;//All incidents earlier than 2025 are considered legacy
const lastYear = new Date().getFullYear() - 1;
const previousYearIncidentsText = (lastYear === incidentsStartYear) ? `${lastYear} Incidents` : `${incidentsStartYear} - ${lastYear} Incidents`;

export const mapLayerTitles = {
    PlanningArea: 'Planning Area',
    Origin: 'Initial Planning Area',
    PublishedPlanningAreas: 'Published Planning Areas',
    InitialIncidentPointOfOrigin: 'Initial Point of Origin',
    PODSSA: 'Potential Operation Delineations (PODs)',
    MUNOSSA: 'Multi-Unit Shape',
    UNOSSA: 'Unit Boundary',
    SUNOSSA: 'Sub-Unit Non-Overlapping Shape',
    SUOSSA: 'Sub-Unit Overlapping Shape',
    OtherUnitSA: 'Other Unit Shape',
    UserDefinedSA: 'User Defined Strategic Shapes',
    UserDefinedCOA: 'User Defined Course of Action Shapes',
    PODSCOA: 'Potential Operation Delineations (PODs)',
    MUNOSCOA: 'Multi-Unit Shape',
    UNOSCOA: 'Unit Boundary',
    SUNOSCOA: 'Sub-Unit Non-Overlapping Shape',
    SUOSCOA: 'Sub-Unit Overlapping Shape',
    OtherUnitCOA: 'Other Unit Shape',
    IncidentStrategicCOA: 'Incident Course of Action',
    Ignition: 'Ignition',
    Barrier: 'Barrier',
    Mask: 'Mask',
    LandscapeExtent: 'Landscape Extent',
    FSPro_Probability: 'Burn Probability',
    FSPro_FlameLength: 'Average Flame Length',
    FSPro_ArrivalTime: 'Average Arrival Time',
    FarsiteArrivalTimeOperational: 'FARSITE Arrival Time (Complete for Operational Use)',
    FarsiteArrivalTimeStrategic: 'FARSITE Arrival Time (Complete for Strategic Use)',
    MttArrivalTimeOperational: 'MTT Arrival Time (Complete for Operational Use)',
    MttArrivalTimeStrategic: 'MTT Arrival Time (Complete for Strategic Use)',
    Perimeters: 'Unpublished Perimeters',
    PublishedPerimeters: 'Published Perimeters',
    WfdssInitiatedDecision: 'Pending Decisions',
    WfdssInitiatedDecisionApproved: 'Approved Decisions',
    WfdssInitiatedDecisionStrategyHasBeenMet: 'Strategy Has Been Met',
    WfdssInitiatedDecisionPreviousYears: previousYearIncidentsText,
    WfdssLegacyIncident: 'WFDSS Legacy Incident Points'
}